<template>
  <div
    class="option"
    :class="getOptionClass"
    @click="$emit('selectionChanged', optionKey)"
  >
    <div class="optionCircle">
      <CircleComponent
        :current-class="getCircleClass"
        :not-circle="notCircle"
      ></CircleComponent>
    </div>
    <!--<div class="ql-container ql-snow block">
      <div class="ql-editor">-->
    <div class="optionDescription" v-html="description"></div>
    <!--</div>
    </div>-->
  </div>
</template>

<script>
import CircleComponent from './Circle'
export default {
  name: 'OptionComponent',
  components: { CircleComponent },
  props: ['selected', 'description', 'optionKey', 'notCircle'],
  computed: {
    getCircleClass: function() {
      if (this.selected) {
        return 'activeDot'
      } else {
        return 'notSelectedDot'
      }
    },
    getOptionClass: function() {
      if (this.selected) {
        return 'optionSelected'
      } else {
        return 'optionNotSelected'
      }
    },
  },
}
</script>

<style scoped>
.optionDescription {
  margin-left: 16px;
  margin-top: 11px;
  margin-bottom: 11px;
  font-family: Roboto-Regular;
  font-size: 14px;
  color: #343c4b;
}
.optionCircle {
  margin-left: 16px;
  margin-top: 11px;
  margin-bottom: 11px;
}
.option {
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-top: 16px;
  border-radius: 2px;
  border: 1px solid rgba(155, 155, 155, 0.2);
}
.optionSelected {
  background: #efeef3;
  box-shadow: inset 4px 0 0 0 #0988f4;
}
.optionNotSelected {
  background: #ffffff;
}

/*.block {
  border: none !important;
  font-size: 16px !important;
}
.block .ql-editor {
  padding: 4px 0px !important;
}*/
</style>
